import {DotSeparator} from 'common/components/dot_separator';
import {timeSince} from 'common/utils';
import {Reviewer} from 'iq-interview_guides/components/reviewer';
import {InterviewGuideData} from 'iq-interview_guides/types';

type HeroMetaProps = Pick<
  InterviewGuideData,
  'experiences' | 'questions' | 'updated_at' | 'reviewer'
>;

function candidateReportCount(count: number): string {
  if (count === 1) return '1 candidate report';
  return `${count} candidate reports`;
}

export function HeroMeta({experiences, questions, updated_at, reviewer}: HeroMetaProps) {
  return (
    <div className='flex items-center gap-2 mt-1 text-sm text-gray-500 flex-wrap'>
      <div>{candidateReportCount(experiences.length)}</div>
      <DotSeparator />
      <div>{questions.length} practice questions</div>
      <DotSeparator />
      <div>Updated {timeSince(updated_at)}</div>
      <Reviewer reviewer={reviewer} />
    </div>
  );
}
